import { render, staticRenderFns } from "./dichiarazioniMobile.vue?vue&type=template&id=2f3fb8ea&scoped=true&"
import script from "./dichiarazioniMobile.vue.ts?vue&type=script&lang=ts&"
export * from "./dichiarazioniMobile.vue.ts?vue&type=script&lang=ts&"
import style0 from "./dichiarazioniMobile.vue?vue&type=style&index=0&id=2f3fb8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3fb8ea",
  null
  
)

export default component.exports